export const AEM_ROUTE_ERROR = {
    NOT_FOUND: 'NOT_FOUND',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
};
export const AEM_URL = process.env.REACT_APP_AEM_URL;
export const AEM_URL_SUFFIX = `/content/pearl/us/en`;
export const AEM_RESPONSE_FORMAT = '.json';
